// Third party
import { createSelector } from '@reduxjs/toolkit';

// Data
import { DEFAULT_CURRENCY } from '../../data';

// Types
import { RootState } from '../index';
import { TCurrency } from '../../types';

const getCurrencies = (state: RootState) => state.commonReducer.platformData.currencies;

const getUserCurrencyId = (state: RootState) => state.authReducer.authenticateUser?.personnel?.paymentCurrencyId;

const getShopCurrencyCode = (state: RootState) => state.authReducer.authenticateUser?.shop?.currency;

const getIsDrawerOpen = (state: RootState) => state.commonReducer.isOpenDrawer;

const getPlatformData = (state: RootState) => state.commonReducer.platformData;

const getPasswordValidation = (state: RootState) => state.commonReducer.passwordValidation;

const getIsOpenPagesNav = (state: RootState) => state.commonReducer.isOpenPagesNav;

const getCurrencyById = createSelector(
  [getCurrencies, getUserCurrencyId],
  (currencies, currencyId) => (id: number | undefined) => currencies?.find(
    (currency: TCurrency) => currency.id
          === (id || currencyId),
  ) || DEFAULT_CURRENCY,
);

const getCurrencyByCode = createSelector(
  [getCurrencies, getShopCurrencyCode],
  (currencies, currencyCode) => () => currencies?.find(
    (currency: TCurrency) => currency.code?.toLowerCase()
      === currencyCode?.toLowerCase(),
  ) || DEFAULT_CURRENCY,
);

const getCurrencyByName = (state: RootState) => (currencyName: string) => {
  const currencies = getCurrencies(state);
  return (
    currencies?.find(
      (currency: TCurrency) => currency.name?.toLowerCase() === currencyName?.toLowerCase(),
    ) || DEFAULT_CURRENCY
  );
};

const getIsOpenRangePicker = (state: RootState) => state.commonReducer.isOpenRangePicker;

const getSelectedFilterItems = (state: RootState) => state.commonReducer.selectedFilterItems;

const getIsPrintMode = (state: RootState) => state.commonReducer.isPrintMode;

const getSelectedLang = (state: RootState) => state.commonReducer.selectedLanguage;

const getIsOpenReleaseNav = (state: RootState) => state.commonReducer.isOpenReleaseNav;

const getIsOpenPricingDialog = (state: RootState) => state.commonReducer.isOpenPricingDialog;

export {
  getCurrencyById,
  getCurrencyByCode,
  getPlatformData,
  getPasswordValidation,
  getIsDrawerOpen,
  getIsOpenPagesNav,
  getIsOpenRangePicker,
  getSelectedFilterItems,
  getIsPrintMode,
  getSelectedLang,
  getIsOpenReleaseNav,
  getIsOpenPricingDialog,
  getCurrencyByName,
};
